import { put, takeLatest, select } from 'redux-saga/effects';
import { request } from '../components/utils';
import * as selectors from './selectors';

export function* getCFBSchedules(action) {
	try {
		const user = yield select(selectors.user);
		const season = action?.payload?.season || new Date().getFullYear();
		const result = yield request({}, `/api/cfb/schedules?season=${season}`, 'GET', user?.token);
		const data = result?.data?.data || result?.data || [];
		yield put({ type: 'GET_CFB_SCHEDULES_SUCCESS', payload: data });
	} catch (e) {
		yield put({ type: 'GET_CFB_SCHEDULES_ERROR', payload: { message: e?.message || 'Failed to load CFB schedules' } });
	}
}

export function* getCFBTeams(action) {
	try {
		const user = yield select(selectors.user);
		const result = yield request({}, `/api/cfb/teams`, 'GET', user?.token);
		const data = result?.data?.data || result?.data || [];
		yield put({ type: 'GET_CFB_TEAMS_SUCCESS', payload: data });
	} catch (e) {
		yield put({ type: 'GET_CFB_TEAMS_ERROR', payload: { message: e?.message || 'Failed to load CFB teams' } });
	}
}

export function* getCFBHealthScores(action) {
	try {
		const user = yield select(selectors.user);
		const result = yield request({}, `/api/cfb/healthScores`, 'GET', user?.token);
		const data = result?.data?.data?.teamInfo || result?.data?.teamInfo || [];
		yield put({ type: 'GET_CFB_HEALTH_SCORES_SUCCESS', payload: data });
	} catch (e) {
		yield put({ type: 'GET_CFB_HEALTH_SCORES_ERROR', payload: { message: e?.message || 'Failed to load CFB health scores' } });
	}
}

export function* getCFBMatchup(action) {
	try {
		const user = yield select(selectors.user);
		const { homeTeamID, awayTeamID, matchID } = action?.payload || {};
		let url = `/api/cfb/matchup?homeTeamID=${homeTeamID}&awayTeamID=${awayTeamID}`;
		if (matchID) url += `&matchID=${matchID}`;
		const result = yield request({}, url, 'GET', user?.token);
		const data = result?.data?.data || result?.data || {};
		yield put({ type: 'GET_CFB_MATCHUP_SUCCESS', payload: data });
	} catch (e) {
		yield put({ type: 'GET_CFB_MATCHUP_ERROR', payload: { message: e?.message || 'Failed to load CFB matchup' } });
	}
}

export function* getCFBPlayer(action) {
	try {
		const user = yield select(selectors.user);
		const { playerID } = action?.payload || {};
		const result = yield request({}, `/api/cfb/player/${playerID}`, 'GET', user?.token);
		const data = result?.data?.data || result?.data || {};
		yield put({ type: 'GET_CFB_PLAYER_SUCCESS', payload: data });
	} catch (e) {
		yield put({ type: 'GET_CFB_PLAYER_ERROR', payload: { message: e?.message || 'Failed to load CFB player' } });
	}
}

export function* getCFBPlayerNews(action) {
	try {
		const user = yield select(selectors.user);
		const { playerID } = action?.payload || {};
		const result = yield request({}, `/api/cfb/player/${playerID}/news`, 'GET', user?.token);
		const data = result?.data?.data || result?.data || {};
		yield put({ type: 'GET_CFB_PLAYER_NEWS_SUCCESS', payload: data });
	} catch (e) {
		yield put({ type: 'GET_CFB_PLAYER_NEWS_ERROR', payload: { message: e?.message || 'Failed to load CFB player news' } });
	}
}

export function* watchCFBSagas() {
	yield takeLatest('GET_CFB_SCHEDULES', getCFBSchedules);
	yield takeLatest('GET_CFB_TEAMS', getCFBTeams);
	yield takeLatest('GET_CFB_HEALTH_SCORES', getCFBHealthScores);
	yield takeLatest('GET_CFB_MATCHUP', getCFBMatchup);
	yield takeLatest('GET_CFB_PLAYER', getCFBPlayer);
	yield takeLatest('GET_CFB_PLAYER_NEWS', getCFBPlayerNews);
}
